module.exports = __webpack_public_path__ + "img/coupon_steps.c88f2300.png";